import { render, staticRenderFns } from "./VerifiedLable.vue?vue&type=template&id=1c41a918&scoped=true"
import script from "./VerifiedLable.vue?vue&type=script&lang=js"
export * from "./VerifiedLable.vue?vue&type=script&lang=js"
import style0 from "./VerifiedLable.vue?vue&type=style&index=0&id=1c41a918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c41a918",
  null
  
)

export default component.exports